import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { CAMERA_SVG, MOBILE_SVG } from "../utils/svgs";
import { AppBottomSheet } from "./Generic/AppBottomSheet";
import { AppBoxActionCard } from "./Generic/AppBoxActionCard";
import { AppBoxActionCards } from "./Generic/AppBoxActionCards";
interface Props {
  isScanningNewDocument: boolean;
  handleCloseDocumentNameDialog?: () => void;
  isUploadOptionsOpen: boolean;
  setUploadOptionsOpen: (isOpen: boolean) => void;
  handleClickOpenFromGallery: () => void;
  handleScanNewDocument: () => void;
  handleUploadFromCamera: () => void;
}

const DocumentUploadBottomSheet = ({
  isUploadOptionsOpen,
  setUploadOptionsOpen,
  handleClickOpenFromGallery,
  handleUploadFromCamera,
}: Props) => {
  return (
    <div className="DocumentUploadActions">
      <AppBottomSheet
        isOpen={isUploadOptionsOpen}
        title={translate(STRINGS.HOW_WOULD_YOU_LIKE_TO_TO_UPLOAD_THE_FILE)}
        onRequestClose={() => setUploadOptionsOpen(false)}
      >
        <AppBoxActionCards>
          <AppBoxActionCard
            className="DocumentUploadActions_uploadOptionCard"
            icon={CAMERA_SVG}
            label={translate(STRINGS.SCAN_A_PHOTO)}
            onClick={() => {
              setUploadOptionsOpen(false);
              handleUploadFromCamera();
            }}
          />
          <AppBoxActionCard
            className="DocumentUploadActions_uploadOptionCard"
            icon={MOBILE_SVG}
            label={translate(STRINGS.UPLOAD_FROM_GALLERY)}
            onClick={() => {
              setUploadOptionsOpen(false);
              handleClickOpenFromGallery();
            }}
          />
        </AppBoxActionCards>
      </AppBottomSheet>
    </div>
  );
};

export default React.memo(DocumentUploadBottomSheet);
